import { render, staticRenderFns } from "./SeparateMileage.vue?vue&type=template&id=5ae57936&lang=pug"
import script from "./SeparateMileage.vue?vue&type=script&lang=js"
export * from "./SeparateMileage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports